import React from 'react';
import { Container, Button } from 'react-bootstrap';
import bannerImage from '../images/banner.png';
import './Banner.css';

const Banner = () => {
  return (
    <section className="banner-section">
      <div className="banner-image-wrapper">
        <img src={bannerImage} alt="Aroghya Radham Home Care" className="banner-image" />
        {/* <div className="banner-overlay">
          <Container>
            <div className="banner-content">
              <h2 className="banner-subtitle">Welcome To Aroghya Radham</h2>
              <h1 className="banner-title">Best Home Care services in Guntur</h1>
              <p className="banner-description">
                Providing compassionate, professional, and reliable home nursing services 
                dedicated to enhancing the quality of life for you and your loved ones.
              </p>
              <div className="banner-buttons">
                <Button href="tel:+919281474570" variant="info" size="lg" className="me-3">
                  Contact Us
                </Button>
                <Button href="/about" variant="outline-light" size="lg">
                  About Us
                </Button>
              </div>
            </div>
          </Container>
        </div> */}
      </div>
    </section>
  );
};

export default Banner;
